import React, { PropsWithChildren } from 'react'
import { makeStyles } from '@material-ui/core'
import { getVerbalColors } from 'helpers'
import { Button } from 'foundations-library/components'

const jss = (theme) => {
    const { colors } = theme['foundations-library'] || {}
    const verbalColors = getVerbalColors(colors)

    return {
        container: {
            maxWidth: 1000,
            margin: '0 auto'
        },
        tableWrapper: {
            margin: '0 auto',
            border: `1px solid ${verbalColors['neutral-100']}`,
            padding: '20px',
            borderRadius: '10px'
        },
        addButtonContainer: {
            display: 'flex',
            justifyContent: 'end',
            marginBottom: '40px'
        }
    }
}

const useStyles = makeStyles(jss)

type PropsType = {
    onClickAddNew(): unknown,
    addButtonText: string
}

/**
 *
 */
const ListContainer = ({
    onClickAddNew,
    addButtonText = 'Add new',
    children
}: PropsWithChildren<PropsType>): JSX.Element => {
    const classes = useStyles()

    return <div className={classes.container} >
        <div data-testid='sms-tabs-list'>
            <div className={classes.tableWrapper}>
                <div className={classes.addButtonContainer}>
                    <Button onClick={onClickAddNew} icon='add' iconLeft>
                        {addButtonText}
                    </Button>
                </div>
                {children}
            </div>
        </div>
    </div>
}

export default ListContainer
